<template>
  <section
    id="demographics"
    class="co-bg-striped"
  >
    <div class="co-container-sm px-4 py-20">
      <h2 class="co-heading-2 mb-12 leading-normal">
        年齢や性別に関係なく<br>スキル習得できる
      </h2>
      <div class="flex flex-col text-center md:flex-row">
        <div class="mb-9 w-full px-0 md:mb-0 md:w-1/2 md:pr-6">
          <img
            src="~/assets/images/Te/TeCourse/Webdesign/Demographics/chart-one.svg"
            class="mb-3 w-full"
            :style="{ height: '255px' }"
            loading="lazy"
          >
          <div class="co-display-10 mb-2 font-bold">
            <span>受講生の</span>
            <span class="text-co-primary-500">約<span class="co-display-8 font-bold">50</span>%が<span class="co-display-8 font-bold">30</span>代以上</span>
          </div>
          <p class="mb-0 text-left">
            プログラミングのスキルは若いうちから学ばないと身につかないと思われがちですが、年齢関係なく学習を始めてスキル習得することができます。
          </p>
        </div>
        <div class="w-full px-0 md:w-1/2 md:pl-6">
          <img
            src="~/assets/images/Te/TeCourse/Webdesign/Demographics/chart-two.svg"
            class="mb-3 w-full"
            :style="{ height: '255px' }"
            loading="lazy"
          >
          <div class="co-display-10 mb-2 font-bold">
            <span>受講生の</span>
            <span class="text-co-primary-500"><span class="co-display-8 font-bold">3人</span>に<span class="co-display-8 font-bold">2人</span>が<span class="co-display-8 font-bold">女性</span></span>
          </div>
          <p class="mb-0 text-left">
            プログラミングを学ぶ女性が近年増加傾向。テックアカデミーでは、プログラミングのスキルを習得された受講生の3人に2人が女性です。
          </p>
        </div>
      </div>
      <div class="co-display-13 mb-0 mt-6 flex items-center justify-center text-co-gray-500">
        <div class="inline-block">
          <span class="mr-0 block sm:mr-4 sm:inline">※調査対象 2022年7月1日〜2023年6月30日</span>
          <span>※対象コース：Webデザインコース</span>
        </div>
      </div>
    </div>
  </section>
</template>
